import styled, { css } from "styled-components";

export const ContactContainerOuter = styled.div`
  margin-top: 1.2rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const ContactContainerInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 40%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const OuterWrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  margin-bottom: 15px;
  font-weight: normal;
`;

export const ContactInfoOuter = styled.div`
  display: block;
`;

export const ContactInfo = styled.div`
  justify-self: auto;
  color: ${(props) => props?.color ?? "#767676"};
  font-size: ${(props) => props?.fontSize ?? "14px"};
  font-weight: bold !important;
  padding-left: 4px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const SpecificConditionLabel = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin: 0px;
  color: ${(props) => props?.color ?? "#474747"};
  margin-left: ${(props) => props?.marginLeft ?? "none"};
`;

export const SpecificConditionTitleLabel = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  color: #0a4986;
`;

export const SpecificConditionTitle = styled.div`
  height: 40px;
  gap: 0px;
  border-radius: 5px 5px 0px 0px;
  background: #008395;
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  line-height: 38px;
  text-align: left;
  color: #ffffff;
  padding-left: 10px;
`;

export const ListContent = styled.li`
  color: #474747;
  font-weight: 400;
  margin-left: 20px;
  list-style: none;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 250px));
  gap: 0.25rem;
  margin-bottom: 15px;
  margin-top: 10px;
  font-weight: normal;
`;
